module.exports = __webpack_public_path__ + "static_pc/img/banner.07d0bc6c.png";